import React from 'react';
import { Checkbox } from '@opendate-app/setlist';

export const buildGiftQuestionFormEntries = (questions, savedQuestions) => {
  const key = (i, attr) => `giving_campaign[giving_campaign_custom_fields_attributes][${i}][${attr}]`;
  const entries = [];
  questions.forEach((question, i) => {
    const saved = savedQuestions.find((s) => s.custom_field_id === question.custom_field_id);
    if (saved) entries.push([key(i, 'id'), saved.id]);
    entries.push([key(i, 'custom_field_id'), question.custom_field_id]);
    entries.push([key(i, 'required'), !!question.required]);
  });
  savedQuestions
    .filter((saved) => !questions.some((q) => q.custom_field_id === saved.custom_field_id))
    .forEach((saved, j) => {
      const i = questions.length + j;
      entries.push([key(i, 'id'), saved.id]);
      entries.push([key(i, '_destroy'), '1']);
    });
  return entries;
};

const GiftQuestionsSection = ({ giftFields = [], questions, setQuestions }) => {
  if (giftFields.length === 0) return null;

  const questionFor = (fieldId) => questions.find((q) => q.custom_field_id === fieldId);
  const toggleAsk = (fieldId, asked) => setQuestions(
    asked ? [...questions, { custom_field_id: fieldId, required: false }] : questions.filter((q) => q.custom_field_id !== fieldId),
  );
  const toggleRequired = (fieldId, required) => setQuestions(
    questions.map((q) => (q.custom_field_id === fieldId ? { ...q, required } : q)),
  );

  return (
    <div className="gc-section">
      <div className="gc-section-row">
        <div className="gc-section-info">
          <h3 className="gc-section-title">Gift Questions</h3>
          <p className="gc-section-desc">Choose which gift fields donors answer on this campaign's form.</p>
        </div>
        <div className="gc-section-fields">
          {giftFields.map((field) => {
            const question = questionFor(field.id);
            return (
              <div className="gc-field d-flex align-items-center" style={{ gap: 16 }} key={field.id}>
                <Checkbox
                  id={`gift-question-${field.id}`}
                  label={field.name}
                  aria-label={`Ask ${field.name}`}
                  checked={!!question}
                  onChange={(e) => toggleAsk(field.id, e.target.checked)}
                />
                {question && field.type !== 'CustomFields::Checkbox' && (
                  <Checkbox
                    id={`gift-question-required-${field.id}`}
                    label="Required"
                    aria-label={`Require ${field.name}`}
                    checked={!!question.required}
                    onChange={(e) => toggleRequired(field.id, e.target.checked)}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default GiftQuestionsSection;
